import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./FbCampaigns.module.scss";
import classNames from "classnames/bind";
import { createAxios } from "../../../createInstance";
import { loginSuccess } from "../../../redux/authSlice";
import {
    getAllCustomers,
    createCustomer,
    updateCustomer,
    deleteCustomer,
} from "../../../redux/apiRequest";
import ToastMessage, { showToast } from "../../../Components/ToastMessage";

const cx = classNames.bind(styles);

const AccountAds = () => {
    const user = {
        listAdsAccount: [
            {
                account_id: "123456",
                account_name: "Tài khoản quảng cáo 1",
                listCampaigns: [
                    {
                        id: "123",
                        name: "Chiến dịch 1",
                        status: "active",
                        created_time: "20/08/2025",
                        stop_time: "22/08/2025"
                    },
                    {
                        id: "234",
                        name: "Chiến dịch 2",
                        status: "paused",
                        created_time: "20/08/2025",
                        stop_time: "22/08/2025"
                    },
                    {
                        id: "345",
                        name: "Chiến dịch 3",
                        status: "active",
                        created_time: "20/08/2025",
                        stop_time: "22/08/2025"
                    },
                    {
                        id: "567",
                        name: "Chiến dịch 4",
                        status: "paused",
                        created_time: "20/08/2025",
                        stop_time: "22/08/2025"
                    },
                ]
            },
            {
                account_id: "456789",
                account_name: "Tài khoản quảng cáo 2",
                listCampaigns: [
                    {
                        id: "678",
                        name: "Chiến dịch 5",
                        status: "paused",
                        created_time: "20/08/2025",
                        stop_time: "22/08/2025"
                    },
                    {
                        id: "789",
                        name: "Chiến dịch 6",
                        status: "paused",
                        created_time: "20/08/2025",
                        stop_time: "22/08/2025"
                    },
                    {
                        id: "987",
                        name: "Chiến dịch 7",
                        status: "paused",
                        created_time: "20/08/2025",
                        stop_time: "22/08/2025"
                    },
                    {
                        id: "654",
                        name: "Chiến dịch 8",
                        status: "paused",
                        created_time: "20/08/2025",
                        stop_time: "22/08/2025"
                    },
                ]
            },
        ]
    }

    const [selectedAd, setSelectedAd] = useState(user?.listAdsAccount?.[0] || null);
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);
    const [listCampaigns, setSelectedListCampaigns] = useState(user?.listAdsAccount?.[0].listCampaigns || null);

    const handleSelectChange = (event) => {
        const selectedId = event.target.value;
        const selectedAccount = user?.listAdsAccount?.find(ad => ad.account_id === selectedId);
        setSelectedListCampaigns(selectedAccount.listCampaigns)
        setSelectedAd(selectedAccount);
    };
    const handleCheckboxChange = (campaignId) => {
        setSelectedCampaigns((prevSelected) => {
            if (prevSelected.includes(campaignId)) {
                return prevSelected.filter(id => id !== campaignId);
            } else {
                return [...prevSelected, campaignId];
            }
        });
    };

    // Chọn tất cả / Bỏ chọn tất cả
    const handleSelectAll = () => {
        if (selectedCampaigns.length === listCampaigns.length) {
            setSelectedCampaigns([]);
        } else {
            setSelectedCampaigns(listCampaigns.map(campaign => campaign.id));
        }
    };

    // useEffect(() => {
    //     if (selectedAd) {
    //         getAllCampaign(user?.facebookId, data, user?.accessToken, dispatch, axiosJWT);
    //     }
    // }, [selectedAd]);

    return (
        <main className={cx("main")}>
            {user?.listAdsAccount && (
                <div className={cx("select-container")}>
                    <div>
                        <label>Tài khoản quảng cáo: </label>
                        <select value={selectedAd?.id} onChange={handleSelectChange} className={cx("custom-select")}>
                            {user.listAdsAccount.map((ad, index) => (
                                <option key={index} value={ad.account_id}>
                                    {ad.account_id}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            )}
            <div className={cx("list-campaigns")}>
                <h3>Danh sách chiến dịch</h3>
                <table className={cx("campaign-table")}>
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={selectedCampaigns?.length === listCampaigns?.length}
                                />
                            </th>
                            <th>ID</th>
                            <th>Tên Chiến Dịch</th>
                            <th>Trạng Thái</th>
                            <th>Ngày Tạo</th>
                            <th>Ngày Dừng</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listCampaigns && listCampaigns.length > 0 ? (
                            listCampaigns.map((campaign) => (
                                <tr key={campaign.id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedCampaigns.includes(campaign.id)}
                                            onChange={() => handleCheckboxChange(campaign.id)}
                                        />
                                    </td>
                                    <td>{campaign.id}</td>
                                    <td>{campaign.name}</td>
                                    <td>
                                        <span className={cx(campaign.status.toLowerCase())}>
                                            {campaign.status}
                                        </span>
                                    </td>
                                    <td>{new Date(campaign.created_time).toLocaleString()}</td>
                                    <td>
                                        {campaign.stop_time ? new Date(campaign.stop_time).toLocaleString() : "N/A"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className={cx("no-data")}>Không có chiến dịch nào</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <ToastMessage />
        </main>
    );
};

export default AccountAds;
